package com.eladfinish.bible.contest

import dev.icerock.moko.resources.FontResource
import kotlin.collections.List

internal object CommonMainFonts0 {
  internal val ezrasil_sr: FontResource by lazy { init_ezrasil_sr() }

  internal val kerenm: FontResource by lazy { init_kerenm() }

  internal val keter_medium: FontResource by lazy { init_keter_medium() }

  internal val stam_ashkenaz: FontResource by lazy { init_stam_ashkenaz() }

  internal val stam_sefarad: FontResource by lazy { init_stam_sefarad() }

  internal fun values(): List<FontResource> = listOf(ezrasil_sr, kerenm, keter_medium,
      stam_ashkenaz, stam_sefarad)
}

private fun init_ezrasil_sr(): FontResource = FontResource(fileUrl =
    js("require(\"./fonts/EzraSIL-SR.ttf\")") as String, fontFamily = "ezrasil_sr")

private fun init_kerenm(): FontResource = FontResource(fileUrl =
    js("require(\"./fonts/KerenM.ttf\")") as String, fontFamily = "kerenm")

private fun init_keter_medium(): FontResource = FontResource(fileUrl =
    js("require(\"./fonts/Keter-Medium.ttf\")") as String, fontFamily = "keter_medium")

private fun init_stam_ashkenaz(): FontResource = FontResource(fileUrl =
    js("require(\"./fonts/Stam-Ashkenaz.ttf\")") as String, fontFamily = "stam_ashkenaz")

private fun init_stam_sefarad(): FontResource = FontResource(fileUrl =
    js("require(\"./fonts/Stam-Sefarad.ttf\")") as String, fontFamily = "stam_sefarad")

public actual val SharedRes.fonts.ezrasil_sr: FontResource
  get() = CommonMainFonts0.ezrasil_sr

public actual val SharedRes.fonts.kerenm: FontResource
  get() = CommonMainFonts0.kerenm

public actual val SharedRes.fonts.keter_medium: FontResource
  get() = CommonMainFonts0.keter_medium

public actual val SharedRes.fonts.stam_ashkenaz: FontResource
  get() = CommonMainFonts0.stam_ashkenaz

public actual val SharedRes.fonts.stam_sefarad: FontResource
  get() = CommonMainFonts0.stam_sefarad
